// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod/mini';

export const zAccountBody = z.object({
    country: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    notificationEmails: z.optional(z.array(z.string())),
    organisation: z.optional(z.string())
});

export const zAccountCreateInputBody = z.object({
    agreementAccepted: z.boolean(),
    country: z.string().check(z.regex(/^[A-Z]{2}$/)),
    organisation: z.string().check(z.maxLength(255)),
    timezone: z.string().check(z.minLength(1), z.maxLength(100)),
    userName: z.string().check(z.minLength(1), z.maxLength(120))
});

export const zAccountEntitlements = z.object({
    'account.group.manage': z.boolean(),
    'account.invitation.manage': z.boolean(),
    'account.invitation.view': z.boolean(),
    'account.member.view': z.boolean(),
    'account.project.manage': z.boolean(),
    'account.settings.manage': z.boolean(),
    'cluster.create': z.boolean()
});

export const zAccountIdBody = z.object({
    accountId: z.string()
});

export const zAccountSettingsInputBody = z.object({
    country: z.string().check(z.regex(/^[A-Z]{2}$/)),
    name: z.string().check(z.minLength(1), z.maxLength(255)),
    notification_emails: z.array(z.string()).check(z.minLength(1)),
    organisation: z.string().check(z.maxLength(255))
});

export const zAuthConfigBody = z.object({
    issuer: z.string(),
    pushedAuthorizationRequestEndpoint: z.string(),
    revocationEndpoint: z.string(),
    tokenEndpoint: z.string()
});

export const zBillingStatusBody = z.object({
    billableQuantity: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    currency: z.string(),
    interval: z.string(),
    monthlyEstimate: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    nodeLimit: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    pendingBillableQuantity: z.optional(z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))),
    provider: z.string(),
    quantityEffectiveAt: z.optional(z.iso.datetime()),
    status: z.string(),
    unitPrice: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))
});

export const zClusterBody = z.object({
    id: z.string(),
    name: z.string(),
    nodes: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    projectId: z.string(),
    projectName: z.string(),
    region: z.string(),
    status: z.string()
});

export const zClusterCreateInputBody = z.object({
    mode: z.enum(['direct', 'plan']),
    name: z.string().check(z.minLength(1), z.maxLength(255)),
    networkIpv4: z.string(),
    nodes: z.coerce.bigint().check(z.gte(BigInt(1)), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    nodesArch: z.optional(z.enum(['arm64', 'amd64'])),
    privateSubnetCidrIpv4: z.string(),
    projectId: z.string().check(z.regex(/^prj[0-9a-hjkmnp-tv-z]{26}$/)),
    providerId: z.string().check(z.regex(/^prv[0-9a-hjkmnp-tv-z]{26}$/)),
    publicSubnetCidrIpv4: z.string(),
    region: z.optional(z.string()),
    zone: z.string()
});

export const zClusterMutationBody = z.object({
    id: z.string(),
    operationId: z.string(),
    status: z.string()
});

export const zClusterProjectBody = z.object({
    id: z.string(),
    projectId: z.string().check(z.regex(/^prj[0-9a-hjkmnp-tv-z]{26}$/))
});

export const zClusterProjectInputBody = z.object({
    projectId: z.string().check(z.regex(/^prj[0-9a-hjkmnp-tv-z]{26}$/))
});

export const zClusterResourceBody = z.object({
    address: z.string(),
    providerIdentifier: z.optional(z.string()),
    providerName: z.string(),
    resourceType: z.string()
});

export const zClusterResourcesBody = z.object({
    items: z.nullable(z.array(zClusterResourceBody)),
    observedAt: z.optional(z.iso.datetime()),
    operationId: z.optional(z.string()),
    operationState: z.optional(z.string()),
    stateHash: z.optional(z.string())
});

export const zEmptyBody = z.record(z.string(), z.never());

export const zErrorDetail = z.object({
    location: z.optional(z.string()),
    message: z.optional(z.string()),
    value: z.optional(z.unknown())
});

export const zErrorModel = z.object({
    detail: z.optional(z.string()),
    errors: z.nullish(z.array(zErrorDetail)),
    instance: z.optional(z.url()),
    status: z.optional(z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))),
    title: z.optional(z.string()),
    type: z._default(z.optional(z.url()), 'about:blank')
});

export const zGroupBody = z.object({
    id: z.string().check(z.regex(/^grp[0-9a-hjkmnp-tv-z]{26}$/)),
    name: z.string(),
    role: z.enum(['admin', 'member'])
});

export const zGroupCreateInputBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(120)),
    role: z.enum(['admin', 'member'])
});

export const zGroupInputBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(120)),
    role: z.enum(['admin', 'member'])
});

export const zGroupProjectBody = z.object({
    clusterRole: z.enum([
        'admins',
        'managers',
        'operators',
        'editors',
        'viewers'
    ]),
    id: z.string().check(z.regex(/^prj[0-9a-hjkmnp-tv-z]{26}$/)),
    name: z.string()
});

export const zHealthBody = z.object({
    status: z.enum(['ok'])
});

export const zIdBody = z.object({
    id: z.string()
});

export const zInvitationBody = z.object({
    createdAt: z.iso.datetime(),
    email: z.string(),
    expiresAt: z.iso.datetime(),
    groupId: z.string(),
    groupName: z.string(),
    groupRole: z.string(),
    id: z.string()
});

export const zInvitationInputBody = z.object({
    email: z.email(),
    groupId: z.string().check(z.regex(/^grp[0-9a-hjkmnp-tv-z]{26}$/))
});

export const zInvitationPreviewBody = z.object({
    accountName: z.string(),
    accountOrganisation: z.optional(z.string()),
    currentEmail: z.string(),
    email: z.string(),
    expiresAt: z.iso.datetime(),
    groupId: z.string(),
    groupName: z.string(),
    groupRole: z.string(),
    id: z.string()
});

export const zListBodyAccountBody = z.object({
    items: z.nullable(z.array(zAccountBody))
});

export const zListBodyClusterBody = z.object({
    items: z.nullable(z.array(zClusterBody))
});

export const zListBodyGroupBody = z.object({
    items: z.nullable(z.array(zGroupBody))
});

export const zListBodyGroupProjectBody = z.object({
    items: z.nullable(z.array(zGroupProjectBody))
});

export const zListBodyInvitationBody = z.object({
    items: z.nullable(z.array(zInvitationBody))
});

export const zListBodyString = z.object({
    items: z.nullable(z.array(z.string()))
});

export const zMeBody = z.object({
    email: z.string(),
    name: z.string(),
    sid: z.string(),
    sub: z.string(),
    timezone: z.string()
});

export const zMemberBody = z.object({
    email: z.string(),
    groupId: z.string(),
    groupName: z.string(),
    groupRole: z.string(),
    id: z.string()
});

export const zListBodyMemberBody = z.object({
    items: z.nullable(z.array(zMemberBody))
});

export const zMemberGroupInputBody = z.object({
    groupId: z.string().check(z.regex(/^grp[0-9a-hjkmnp-tv-z]{26}$/))
});

export const zNotificationBody = z.object({
    body: z.string(),
    createdAt: z.iso.datetime(),
    id: z.string(),
    kind: z.string(),
    name: z.string(),
    read: z.boolean()
});

export const zNotificationPageBody = z.object({
    items: z.nullable(z.array(zNotificationBody)),
    nextCursor: z.optional(z.string())
});

export const zNotificationStatusBody = z.object({
    latestId: z.string(),
    unread: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))
});

export const zOperationBody = z.object({
    clusterId: z.string(),
    createdAt: z.iso.datetime(),
    desiredStateDigest: z.string(),
    errorCategory: z.optional(z.string()),
    id: z.string(),
    kind: z.string(),
    message: z.optional(z.string()),
    openTofuVersion: z.optional(z.string()),
    planCreatedAt: z.optional(z.iso.datetime()),
    planKey: z.optional(z.string()),
    planSha256: z.optional(z.string()),
    podplaneVersion: z.optional(z.string()),
    progressMessage: z.optional(z.string()),
    progressStage: z.optional(z.string()),
    state: z.string(),
    updatedAt: z.iso.datetime()
});

export const zListBodyOperationBody = z.object({
    items: z.nullable(z.array(zOperationBody))
});

export const zOperationIdBody = z.object({
    operationId: z.string()
});

export const zOperationLogBody = z.object({
    action: z.optional(z.string()),
    addCount: z.optional(z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))),
    changeCount: z.optional(z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))),
    command: z.string(),
    elapsedSeconds: z.optional(z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))),
    level: z.string(),
    message: z.string(),
    occurredAt: z.iso.datetime(),
    operation: z.optional(z.string()),
    removeCount: z.optional(z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))),
    resourceAddress: z.optional(z.string()),
    resourceType: z.optional(z.string()),
    sequence: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    type: z.string()
});

export const zOperationLogsBody = z.object({
    items: z.nullable(z.array(zOperationLogBody)),
    nextCursor: z.coerce.bigint().check(z.minimum(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))
});

export const zParInputBody = z.object({
    destination: z.string(),
    dpopJkt: z.string(),
    prompt: z.optional(z.enum(['create'])),
    slot: z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9)))
});

export const zProfileInputBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(120)),
    timezone: z.string().check(z.minLength(1), z.maxLength(100))
});

export const zProjectBody = z.object({
    id: z.string().check(z.regex(/^prj[0-9a-hjkmnp-tv-z]{26}$/)),
    name: z.string()
});

export const zListBodyProjectBody = z.object({
    items: z.nullable(z.array(zProjectBody))
});

export const zProjectCreateInputBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(120))
});

export const zProjectGroupBody = z.object({
    clusterRole: z.enum([
        'admins',
        'managers',
        'operators',
        'editors',
        'viewers'
    ]),
    id: z.string(),
    name: z.string()
});

export const zListBodyProjectGroupBody = z.object({
    items: z.nullable(z.array(zProjectGroupBody))
});

export const zProjectGroupInputBody = z.object({
    clusterRole: z.enum([
        'admins',
        'managers',
        'operators',
        'editors',
        'viewers'
    ])
});

export const zProjectInputBody = z.object({
    name: z.string().check(z.minLength(1), z.maxLength(120))
});

export const zProviderBody = z.object({
    awsAccountId: z.optional(z.string()),
    googleProjectId: z.optional(z.string()),
    id: z.string(),
    kind: z.string(),
    region: z.string(),
    verified: z.boolean()
});

export const zListBodyProviderBody = z.object({
    items: z.nullable(z.array(zProviderBody))
});

export const zProviderCreatedBody = z.object({
    id: z.string(),
    status: z.string()
});

export const zProviderInputBody = z.object({
    awsAccountId: z.optional(z.string().check(z.regex(/^[0-9]{12}$/))),
    defaultRegion: z.string().check(z.minLength(3), z.maxLength(64)),
    googleProjectId: z.optional(z.string().check(z.minLength(6), z.maxLength(30))),
    kind: z.enum(['aws', 'google'])
});

export const zProviderRedirectBody = z.object({
    provider: z.string()
});

export const zProviderRegionBody = z.object({
    code: z.string(),
    name: z.string(),
    zones: z.nullable(z.array(z.string()))
});

export const zListBodyProviderRegionBody = z.object({
    items: z.nullable(z.array(zProviderRegionBody))
});

export const zRedirectBody = z.object({
    redirect: z.string()
});

export const zSessionBody = z.object({
    active: z.boolean(),
    createdAt: z.iso.datetime(),
    current: z.boolean(),
    expiresAt: z.iso.datetime(),
    id: z.string(),
    kind: z.enum(['browser', 'cli']),
    lastUsedAt: z.iso.datetime(),
    name: z.string(),
    status: z.enum([
        'Active',
        'Expired',
        'Revoked'
    ])
});

export const zListBodySessionBody = z.object({
    items: z.nullable(z.array(zSessionBody))
});

export const zTokenBody = z.object({
    accessTokenHash: z.string(),
    expiresAt: z.iso.datetime(),
    redirect: z.optional(z.string())
});

export const zWebhookBody = z.object({
    received: z.boolean()
});

export const zListAccountsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zListAccountsResponse = zListBodyAccountBody;

export const zCreateAccountBody = zAccountCreateInputBody;

export const zCreateAccountHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zCreateAccountResponse = zAccountBody;

export const zUpdateAccountBody = zAccountSettingsInputBody;

export const zUpdateAccountHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zUpdateAccountPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zUpdateAccountResponse = zIdBody;

export const zBillingStatusHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zBillingStatusPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zBillingStatusResponse = zBillingStatusBody;

export const zListClustersHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListClustersPath = z.object({
    account: z.string()
});

export const zListClustersQuery = z.object({
    project: z.optional(z.string().check(z.regex(/^prj[0-9a-hjkmnp-tv-z]{26}$/)))
});

/**
 * OK
 */
export const zListClustersResponse = zListBodyClusterBody;

export const zCreateClusterBody = zClusterCreateInputBody;

export const zCreateClusterHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zCreateClusterPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zCreateClusterResponse = zClusterMutationBody;

export const zDestroyClusterHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zDestroyClusterPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zDestroyClusterResponse = zOperationIdBody;

export const zUpdateClusterBody = z.record(z.string(), z.unknown());

export const zUpdateClusterHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zUpdateClusterPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zUpdateClusterResponse = zClusterMutationBody;

export const zGetClusterLoginConfigHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zGetClusterLoginConfigPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * Podplane cluster configuration
 */
export const zGetClusterLoginConfigResponse = z.string();

export const zListClusterOperationsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListClusterOperationsPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zListClusterOperationsResponse = zListBodyOperationBody;

export const zUpdateClusterProjectBody = zClusterProjectInputBody;

export const zUpdateClusterProjectHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zUpdateClusterProjectPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zUpdateClusterProjectResponse = zClusterProjectBody;

export const zListClusterResourcesHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListClusterResourcesPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zListClusterResourcesResponse = zClusterResourcesBody;

export const zGetEntitlementsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zGetEntitlementsPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zGetEntitlementsResponse = zAccountEntitlements;

export const zListGroupsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListGroupsPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zListGroupsResponse = zListBodyGroupBody;

export const zCreateGroupBody = zGroupCreateInputBody;

export const zCreateGroupHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zCreateGroupPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zCreateGroupResponse = zGroupBody;

export const zDeleteGroupHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zDeleteGroupPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zDeleteGroupResponse = zEmptyBody;

export const zUpdateGroupBody = zGroupInputBody;

export const zUpdateGroupHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zUpdateGroupPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zUpdateGroupResponse = zGroupBody;

export const zListGroupProjectsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListGroupProjectsPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zListGroupProjectsResponse = zListBodyGroupProjectBody;

export const zListInvitationsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListInvitationsPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zListInvitationsResponse = zListBodyInvitationBody;

export const zInviteMemberBody = zInvitationInputBody;

export const zInviteMemberHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zInviteMemberPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zInviteMemberResponse = zIdBody;

export const zRevokeInvitationHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zRevokeInvitationPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zRevokeInvitationResponse = zEmptyBody;

export const zListMembersHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListMembersPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zListMembersResponse = zListBodyMemberBody;

export const zAssignMemberGroupBody = zMemberGroupInputBody;

export const zAssignMemberGroupHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zAssignMemberGroupPath = z.object({
    account: z.string(),
    member: z.string()
});

/**
 * OK
 */
export const zAssignMemberGroupResponse = zIdBody;

export const zListNotificationsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListNotificationsPath = z.object({
    account: z.string()
});

export const zListNotificationsQuery = z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.coerce.bigint().check(z.gte(BigInt(1)), z.lte(BigInt(50))))
});

/**
 * OK
 */
export const zListNotificationsResponse = zNotificationPageBody;

export const zNotificationStatusHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zNotificationStatusPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zNotificationStatusResponse = zNotificationStatusBody;

export const zListProjectsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListProjectsPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zListProjectsResponse = zListBodyProjectBody;

export const zCreateProjectBody = zProjectCreateInputBody;

export const zCreateProjectHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zCreateProjectPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zCreateProjectResponse = zProjectBody;

export const zDeleteProjectHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zDeleteProjectPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zDeleteProjectResponse = zEmptyBody;

export const zUpdateProjectBody = zProjectInputBody;

export const zUpdateProjectHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zUpdateProjectPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zUpdateProjectResponse = zProjectBody;

export const zListProjectGroupsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListProjectGroupsPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zListProjectGroupsResponse = zListBodyProjectGroupBody;

export const zRemoveProjectGroupHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zRemoveProjectGroupPath = z.object({
    account: z.string(),
    id: z.string(),
    group: z.string()
});

/**
 * OK
 */
export const zRemoveProjectGroupResponse = zEmptyBody;

export const zAssignProjectGroupBody = zProjectGroupInputBody;

export const zAssignProjectGroupHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zAssignProjectGroupPath = z.object({
    account: z.string(),
    id: z.string(),
    group: z.string()
});

/**
 * OK
 */
export const zAssignProjectGroupResponse = zProjectGroupBody;

export const zListProvidersHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListProvidersPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zListProvidersResponse = zListBodyProviderBody;

export const zCreateProviderBody = zProviderInputBody;

export const zCreateProviderHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zCreateProviderPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zCreateProviderResponse = zProviderCreatedBody;

export const zDeleteProviderHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zDeleteProviderPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zDeleteProviderResponse = zEmptyBody;

export const zListSessionsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListSessionsPath = z.object({
    account: z.string()
});

/**
 * OK
 */
export const zListSessionsResponse = zListBodySessionBody;

export const zRevokeSessionHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zRevokeSessionPath = z.object({
    account: z.string(),
    id: z.string()
});

/**
 * OK
 */
export const zRevokeSessionResponse = zEmptyBody;

export const zBillingPortalHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zBillingPortalResponse = zProviderRedirectBody;

export const zAuthCallbackQuery = z.object({
    code: z.string(),
    state: z.string()
});

/**
 * OK
 */
export const zAuthCallbackResponse = zRedirectBody;

export const zAuthClearHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zAuthClearResponse = zRedirectBody;

/**
 * OK
 */
export const zAuthConfigResponse = zAuthConfigBody;

export const zAuthLoginQuery = z.object({
    destination: z.optional(z.string()),
    slot: z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zAuthLoginResponse = zRedirectBody;

export const zAuthParBody = zParInputBody;

export const zAuthParHeaders = z.object({
    DPoP: z.string()
});

/**
 * OK
 */
export const zAuthParResponse = zRedirectBody;

export const zAuthRefreshHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9)))),
    DPoP: z.string()
});

/**
 * OK
 */
export const zAuthRefreshResponse = zTokenBody;

export const zAuthRevokeHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9)))),
    DPoP: z.string()
});

/**
 * OK
 */
export const zAuthRevokeResponse = zRedirectBody;

export const zAuthTokenHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9)))),
    DPoP: z.string()
});

/**
 * OK
 */
export const zAuthTokenResponse = zTokenBody;

/**
 * OK
 */
export const zHealthResponse = zHealthBody;

export const zGetInvitationHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zGetInvitationPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zGetInvitationResponse = zInvitationPreviewBody;

export const zAcceptInvitationBody = z.record(z.string(), z.unknown());

export const zAcceptInvitationHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zAcceptInvitationPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zAcceptInvitationResponse = zAccountIdBody;

export const zCliMeHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zCliMeResponse = zMeBody;

export const zUpdateProfileBody = zProfileInputBody;

export const zUpdateProfileHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zUpdateProfileResponse = zMeBody;

export const zMarkNotificationReadBody = z.record(z.string(), z.unknown());

export const zMarkNotificationReadHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zMarkNotificationReadPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zMarkNotificationReadResponse = zEmptyBody;

export const zMarkNotificationUnreadBody = z.record(z.string(), z.unknown());

export const zMarkNotificationUnreadHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zMarkNotificationUnreadPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zMarkNotificationUnreadResponse = zEmptyBody;

export const zGetOperationHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zGetOperationPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zGetOperationResponse = zOperationBody;

export const zApproveOperationBody = z.record(z.string(), z.unknown());

export const zApproveOperationHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zApproveOperationPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zApproveOperationResponse = zOperationBody;

export const zGetOperationLogsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zGetOperationLogsPath = z.object({
    id: z.string()
});

export const zGetOperationLogsQuery = z.object({
    after: z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.maximum(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })))
});

/**
 * OK
 */
export const zGetOperationLogsResponse = zOperationLogsBody;

export const zRetryOperationBody = z.record(z.string(), z.unknown());

export const zRetryOperationHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zRetryOperationPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zRetryOperationResponse = zOperationBody;

export const zListProviderRegionsHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zListProviderRegionsPath = z.object({
    kind: z.enum(['aws', 'google'])
});

/**
 * OK
 */
export const zListProviderRegionsResponse = zListBodyProviderRegionBody;

/**
 * OK
 */
export const zReadinessResponse = zHealthBody;

export const zListUserSessionsHeaders = z.object({
    'Nadrama-CLI-Version': z.string()
});

/**
 * OK
 */
export const zListUserSessionsResponse = zListBodySessionBody;

export const zRevokeCurrentCliSessionHeaders = z.object({
    'Nadrama-CLI-Version': z.string()
});

/**
 * OK
 */
export const zRevokeCurrentCliSessionResponse = zEmptyBody;

export const zRevokeUserSessionBody = z.record(z.string(), z.unknown());

export const zRevokeUserSessionHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

export const zRevokeUserSessionPath = z.object({
    id: z.string()
});

/**
 * OK
 */
export const zRevokeUserSessionResponse = zEmptyBody;

export const zListTimezonesHeaders = z.object({
    'X-Nadrama-Auth-Slot': z.optional(z.coerce.bigint().check(z.gte(BigInt(0)), z.lte(BigInt(9))))
});

/**
 * OK
 */
export const zListTimezonesResponse = zListBodyString;

export const zStripeWebhookBody = z.string();

export const zStripeWebhookHeaders = z.object({
    'Stripe-Signature': z.optional(z.string())
});

/**
 * OK
 */
export const zStripeWebhookResponse = zWebhookBody;
